module.exports = __webpack_public_path__ + "static/media/empty_cart.73a3d991.svg";